import {AfterViewInit, Component, OnInit} from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-messagerie',
  templateUrl: './messagerie.component.html',
  styleUrls: ['./messagerie.component.scss']
})
export class MessagerieComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    $('.heading-compose').click(() => {
      $('.side-two').css({
        left: '0'
      });
    });

    $('.newMessage-back').click(() => {
      $('.side-two').css({
        left: '-100%'
      });
    });
  }

}
